import { CROSS_TAB_CHANNEL } from './constants'

// Single shared instance — avoids same-tab cross-talk when multiple files use the same channel name.
let instance: BroadcastChannel | null = null

export function getCrossTabChannel(): BroadcastChannel | null {
  if (typeof window === 'undefined' || !window.BroadcastChannel) return null
  instance ??= new BroadcastChannel(CROSS_TAB_CHANNEL)
  return instance
}
